import { render, staticRenderFns } from "./step_budget_archive.vue?vue&type=template&id=2cdc8c8a&scoped=true"
import script from "./step_budget_archive.vue?vue&type=script&lang=js"
export * from "./step_budget_archive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc8c8a",
  null
  
)

export default component.exports